/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessPlatformResVo
 */
export interface BusinessPlatformResVo {
    /**
     * 平台ID
     * @type {number}
     * @memberof BusinessPlatformResVo
     */
    id?: number;
    /**
     * 平台名称
     * @type {string}
     * @memberof BusinessPlatformResVo
     */
    name?: string;
}

/**
 * Check if a given object implements the BusinessPlatformResVo interface.
 */
export function instanceOfBusinessPlatformResVo(value: object): value is BusinessPlatformResVo {
    return true;
}

export function BusinessPlatformResVoFromJSON(json: any): BusinessPlatformResVo {
    return BusinessPlatformResVoFromJSONTyped(json, false);
}

export function BusinessPlatformResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessPlatformResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function BusinessPlatformResVoToJSON(json: any): BusinessPlatformResVo {
    return BusinessPlatformResVoToJSONTyped(json, false);
}

export function BusinessPlatformResVoToJSONTyped(value?: BusinessPlatformResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

